<template>
  <v-app-bar
    app
    absolute
    id="navbarDesktop"
    elevate-on-scroll
    height="85"
  >
    <router-link to="/" @click.native="$gtag.clickButton('Home')">
      <v-img width="215" class="" src="/img/teamhive-logohz-sitenav.svg"></v-img>
    </router-link>
    <v-spacer></v-spacer>
    <div class="d-flex align-center">
      <v-menu
        bottom
        offset-y
        :min-width="menuMinWidth"
        :close-on-content-click="false"
        open-on-hover
        v-model="watchMenu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn text :style="buttonStyle" v-on="on" v-bind="attrs" small>
            <v-icon left>mdi-television</v-icon>
            Watch
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item to="/broadcasts" exact @click.native="watchMenu = false; $gtag.clickButton('See More Broadcasts')">
            <v-list-item-content>All Categories</v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-view-grid</v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item-content>High School</v-list-item-content>
            </template>
            <v-list-item
              exact
              :to="urlByCategoryId(1)"
              @click.native="watchMenu = false; $gtag.clickButton(nameByCategoryId(1));"
            >
              <v-list-item-content>All</v-list-item-content>
            </v-list-item>
            <v-list-item
              exact
              v-for="category in highSchoolCategories"
              :key="category.name + category.id"
              :to="
                '/broadcasts/' +
                  category.id +
                  '/' +
                  seoName(category.name)
              "
              @click.native="watchMenu = false; $gtag.clickButton(category.name);"
            >
              <v-list-item-content>
                {{ category.name }}
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-for="item in noSubItems"
            :key="item.name + item.id"
            exact
            :to="urlByCategoryId(item.id)"
            @click.native="watchMenu = false; $gtag.clickButton(item.name);"
          >
            <v-list-item-content>{{ item.name }}</v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-play-box-outline</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item-content>Local Shows</v-list-item-content>
            </template>
            <v-list-item
              exact
              :to="urlByCategoryId(4)"
              @click.native="watchMenu = false; $gtag.clickButton(nameByCategoryId(4));"
            >
              <v-list-item-content>All</v-list-item-content>
            </v-list-item>
            <v-list-item
              exact
              v-for="category in localCategories"
              :key="category.name + category.id"
              :to="
                '/broadcasts/' +
                  category.id +
                  '/' +
                  seoName(category.name)
              "
              @click.native="watchMenu = false; $gtag.clickButton(category.name);"
            >
              <v-list-item-content>
                {{ category.name }}
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-menu>
      <v-menu bottom offset-y :min-width="menuMinWidth" open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn text :style="buttonStyle" v-on="on" small>
            <v-icon left>mdi-bell-outline</v-icon>
            Schools
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item exact :to="urlByCategoryId(1)" @click.native="$gtag.clickButton(nameByCategoryId(1));">
            <v-list-item-content>All</v-list-item-content>
          </v-list-item>
          <div class="d-flex flex-wrap" style="max-width: 750px">
            <v-list-item
              style="max-width: 250px;"
              exact
              v-for="category in highSchoolCategories"
              :key="category.name + category.id"
              :to="
                '/broadcasts/' + category.id + '/' + seoName(category.name)
              "
              @click.native="$gtag.clickButton(category.name);"
            >
              <v-list-item-content>{{ category.name }}</v-list-item-content>
            </v-list-item>
          </div>
        </v-list>
      </v-menu>
      <v-btn text :style="buttonStyle" to="/advertise" @click.native="$gtag.clickButton('Advertise');" small>
        Advertise
      </v-btn>
      <v-btn text :style="buttonStyle" to="/signup" @click.native="$gtag.clickButton('Get Notified');" small>
        Get Notified
      </v-btn>
      <v-btn text :style="buttonStyle" to="/contact" @click.native="$gtag.clickButton('Contact Us');" small>
        Contact Us
      </v-btn>
      <header-search-bar></header-search-bar>
    </div>
  </v-app-bar>
</template>
<script>
import broadcastCategoriesMixin from '../mixins/broadcastCategoriesMixin';
import seoNameMixin from '../mixins/seoNameMixin';
export default {
  mixins: [broadcastCategoriesMixin, seoNameMixin],
  data: () => ({
    menuMinWidth: 250,
    watchMenu: false,
  }),
  computed: {
    buttonStyle() {
      return {
        color: '#707E8B',
        textTransform: 'capitalize',
        fontSize: '14px',
        fontFamily: 'Lato, sans-serif',
      };
    },
  },
};
</script>
<style>
#navbarDesktop a {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  text-decoration: none;
  color: #777;
}
#navbarDesktop a:hover {
  color: #fff;
}
#navbarDesktop a.active {
  color: #428bca;
}
#navbarDesktop ul {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
}
#navbarDesktop ul li {
  font-size: 16px;
  font-weight: 500;
  padding: 15px;
}
.navbar-brand {
  font-size: 18px;
}
.navbar-brand-divider {
  height: 50px;
}
.v-toolbar__extension {
  padding-left: 0;
  padding-right: 0;
}
.v-list .v-list-item {
  font-size: 14px !important;
  font-family: Lato, sans-serif !important;
}
.dualLogos img {
  height: 40px;
  margin-right: 10px;
}
@media screen and (max-width: 990px) {

  .dualLogos img {
    height: 35px;
    margin-right: 5px;
  }
}
@media screen and (max-width: 875px) {
  .logoCentracom {
    display: none;
  }
}
</style>
